/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Save_PresetInputs */



/**
* | output |
* | --- |
* | "Save Preset" |
*
* @param {Video_Export_Style_Save_PresetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_save_preset = /** @type {((inputs?: Video_Export_Style_Save_PresetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Save_PresetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le prereglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva preimpostazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить предустановку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar predefinição")
	return /** @type {LocalizedString} */ ("Save Preset")
});